var _style, _g, _path, _path2, _path3, _path4, _circle, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDio(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 320 122.8",
    style: {
      enableBackground: "new 0 0 320 122.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#E94D5F;}\r\n\t.st1{fill:url(#SVGID_1_);}\r\n\t.st2{fill:url(#SVGID_2_);}\r\n\t.st3{fill:url(#SVGID_3_);}\r\n\t.st4{fill:url(#SVGID_4_);}\r\n\t.st5{fill:url(#SVGID_5_);}\r\n\t.st6{fill:url(#SVGID_6_);}\r\n\t.st7{fill:url(#SVGID_7_);}\r\n\t.st8{fill:url(#SVGID_8_);}\r\n\t.st9{fill:url(#SVGID_9_);}\r\n\t.st10{fill:url(#SVGID_10_);}\r\n\t.st11{fill:url(#SVGID_11_);}\r\n\t.st12{fill:url(#SVGID_12_);}\r\n\t.st13{fill:url(#SVGID_13_);}\r\n\t.st14{fill:url(#SVGID_14_);}\r\n\t.st15{fill:#0C141F;}\r\n")), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M309.6,110.9v7.9h-35.7v-7.9H309.6z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M270.6,92.3c0,9.6-7.8,17.3-17.3,17.3S236,101.8,236,92.3s7.8-17.3,17.3-17.3S270.6,82.7,270.6,92.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 145.6009,
    y1: 63.2722,
    x2: 235.9584,
    y2: 63.2722
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#56509A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E94D5F"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M218.6,98.9c10.6-8.3,17.4-21.1,17.4-35.6s-6.8-27.3-17.4-35.6c-7.7-6-17.3-9.6-27.8-9.6 c-25,0-45.2,20.2-45.2,45.2s20.2,45.2,45.2,45.2C201.3,108.5,210.9,104.9,218.6,98.9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 10.4336,
    y1: 56.3976,
    x2: 100.7907,
    y2: 56.3976
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2EAAE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4A63A9"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M100.7,60.2V4.3c-12.5,0-23.4,6.6-29.5,16.5c-4.8-1.8-10.1-2.8-15.5-2.8c-25,0-45.2,20.2-45.2,45.2 c0,25,20.2,45.2,45.2,45.2c10.5,0,20.1-3.6,27.8-9.6c10.6-8.3,17.4-21.1,17.4-35.6C100.8,62.2,100.8,61.2,100.7,60.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 105.687,
    y1: 73.7963,
    x2: 140.3421,
    y2: 73.7963
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4A63A9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#56509A"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M122.9,39.1L122.9,39.1c-9.5,0-17.2,7.7-17.2,17.2v52.1c19.1,0,34.7-15.5,34.7-34.7V56.6 C140.3,47,132.5,39.1,122.9,39.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 105.687,
    y1: 21.6719,
    x2: 140.3421,
    y2: 21.6719
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4A63A9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#56509A"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 123,
    cy: 21.7,
    r: 17.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 105.3473,
    y1: 21.6719,
    x2: 140.6815,
    y2: 21.6719
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4A63A9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#56509A"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M123,39.3c-9.7,0-17.7-7.9-17.7-17.7S113.3,4,123,4s17.7,7.9,17.7,17.7S132.8,39.3,123,39.3z M123,4.7 c-9.4,0-17,7.6-17,17s7.6,17,17,17s17-7.6,17-17S132.4,4.7,123,4.7z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDio);
export default __webpack_public_path__ + "static/media/dio.175a1eeb50425aa6fda77a82d4530d65.svg";
export { ForwardRef as ReactComponent };